// Filename: collections/template/calendar/template-calendar-days
define('collections/template/calendar/template-calendar-days',[
    'underscore', 'backbone', 'utils',
    // collection model
    'models/template/calendar/template-calendar-day',
    'collections/calendar/days'
], function(
    // libs
    _, Backbone, U,
    // collection model
    MTemplateCalendarDay,
    // parent
    CCalendarDays
) {

    var CTemplateCalendarDays = CCalendarDays.extend({
        model: MTemplateCalendarDay,

        getAllItems: function() {
            return this.chain().map(function(day) {
                return day.getItems().models;
            }).flatten().value();
        },

        updateItem: function(activity, options) {
            var day = this.getByDayId(activity.get('dayId'));

            if (!day) {
                this.addMissingDays(activity);
            } else {
                day.updateItem(activity, options);
            }

            return this;
        },

        getByDayId: function(dayId) {
            return this.get(dayId);
        },

        addMissingDays: function(activity) {
            var dayId = this.length,
                activityDayId = activity.get('dayId'),
                toAdd = [];

            var dayNameList = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

            // Adding a single week when activity day doesn't exists, filling it with activity
            for (var i = 0; i < 7; i++) {
                toAdd.push({
                    _id: dayId,
                    dayName: dayNameList[i],
                    items: dayId === activityDayId ? [activity] : []
                });
                dayId++;
            }

            this.add(toAdd);
        },

        addBlankWeek: function() {
            var last = this.last(),
                dayId = last ? last.id : 0,
                toAdd = [];
            var dayNameList = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

            for (var i = 0; i < 7; i++) {
                toAdd.push({ _id: ++dayId, dayName: dayNameList[i], items: [] });
                dayId++;
            }

            this.add(toAdd);
        },

    });

    // You don't usually return a collection instantiated
    return CTemplateCalendarDays;
});

